import { useEffect, useMemo, useState } from "react";
import orgConfig from '../../../../config';
import { getAuthenticationConfig, nomarlizePath } from "libs/utils";
import { UserManager, WebStorageStateStore } from 'oidc-client';
import { isFunction } from "coreutils-js";

import { AuthContext } from "./AuthContext";
//@ts-ignore
import { Loading } from '@microui/react-ui';

export const AuthProvider = ({ children, clientId, applicationId, basename = '' }) => {
    const tenantId = window.location.href.replace(`${window.location.origin}/${nomarlizePath(basename)}`, '').split('/').filter(i => !!i)[0];
    const userManager = useMemo(() => {
        let arcValues = '';

        if (clientId == 'applicationuser') {
            arcValues = `tenant_id:${tenantId},application_id:${applicationId || ''}`;
        }

        return new UserManager({
            ...(getAuthenticationConfig(clientId)),
            post_logout_redirect_uri: window.location.origin,
            redirect_uri: `${window.location.origin}/${nomarlizePath(basename + '/login-callback')}`,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            mergeClaims: true,
            acr_values: arcValues
        });
    }, []);
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Lắng nghe khi user thay đổi
        userManager.events.addUserLoaded(user => {
            setUser(user);
        });

        // Lấy thông tin user lần đầu
        userManager.getUser().then(user => {
            setUser(user);
        });
    }, []);

    const value = useMemo(
        () => ({
            user: user,
            refreshUser: (callback) => {
                return new Promise((resolve, reject) => {
                    userManager.signinSilent({
                        acr_values: `tenant_id:${tenantId},application_id:${applicationId || ''}`
                    })
                        .then(data => {
                            resolve(data);
                            if (isFunction(callback)) callback(data);
                        })
                        .catch(err => {
                            reject(err);
                            userManager.signinRedirect();
                        });
                });
            }
        }),
        [user]
    );

    if (!user) {
        return <Loading size="large" loadingText="Đang lấy danh sách kênh của tài khoản..." />;
    }

    return (
        <AuthContext.Provider value={value}>
            {isFunction(children) ? children(value) : children}
        </AuthContext.Provider>
    );
};